import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Landlord.css';
import axios from 'axios';

const TopBar = ({ isSidebarOpen, onMenuClick }) => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [userData, setUserData] = useState(null);
  const [messages, setMessages] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const currentUser = JSON.parse(localStorage.getItem('user'));
  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get('http://localhost:8000/api/user/', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        setUserData(response.data);
      } catch (error) {
        
      }
    };

    if (token) {
      fetchUserData();
    }
  }, [token]);

  // Fetch messages
  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axios.get('http://localhost:8000/api/messages/', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        
        // Filter messages where the landlord is the receiver
        const landlordMessages = response.data.filter(
          message => message.receiver === currentUser.user.id && !message.is_read
        );

        
        setMessages(landlordMessages);
        setUnreadCount(landlordMessages.length);
      } catch (error) {
        console.error('Error fetching messages:', error);
      }
    };

    if (token && currentUser) {
      fetchMessages();
      // Fetch messages every 30 seconds
      const interval = setInterval(fetchMessages, 30000);
      return () => clearInterval(interval);
    }
  }, [token, currentUser]);

  // Mark messages as read
  const handleMarkAsRead = async () => {
    try {
      await axios.post('http://localhost:8000/api/messages/mark-read/', {
        receiver: currentUser.user.id
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setUnreadCount(0);
      setMessages(prevMessages => prevMessages.map(msg => ({ ...msg, is_read: true })));
    } catch (error) {
      console.error('Error marking messages as read:', error);
    }
  };

  // Close dropdown when clicking outside
  const handleClick = (e) => {
    if (!e.target.closest('.messages') && !e.target.closest('.topbar-profile')) {
      setActiveDropdown(null);
    }
  };

  // Toggle dropdown
  const toggleDropdown = (dropdown) => {
    if (dropdown === 'messages') {
      handleMarkAsRead();
    }
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  React.useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <div className="landlord-topbar">
      <div className="topbar-left">
        <button className="menu-toggle" onClick={onMenuClick}>
          <i className={`fas ${isSidebarOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
        <h2 className="dashboard-title text-light"></h2>
      </div>

      <div className="topbar-right">
        <div className="topbar-actions">
          {/* Messages */}
          <div className="messages">
            <button 
              className="message-btn"
              onClick={(e) => {
                e.stopPropagation();
                toggleDropdown('messages');
              }}
            >
              <i className="fas fa-envelope"></i>
              {unreadCount > 0 && (
                <span className="message-badge">{unreadCount}</span>
              )}
            </button>

            {activeDropdown === 'messages' && (
              <div className="topbar-dropdown messages-dropdown">
                <div className="dropdown-header">
                  <h6>Messages</h6>
                  {unreadCount > 0 && (
                    <button className="mark-all-read" onClick={handleMarkAsRead}>
                      Mark all as read
                    </button>
                  )}
                </div>
                <div className="messages-list">
                  {messages.length > 0 ? (
                    messages.map((message) => (
                      <div 
                        key={message.id} 
                        className={`message-item ${!message.is_read ? 'unread' : ''}`}
                        onClick={() => navigate(`/landlord/chat/${message.property}`)}
                      >
                        <i className="fas fa-envelope"></i>
                        <div className="message-content">
                          <p>{message.message}</p>
                          <span>{new Date(message.timestamp).toLocaleString()}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="no-messages">
                      No new messages
                    </div>
                  )}
                </div>
                <div className="dropdown-footer">
                  <Link to="/landlord/inquiries">View all messages</Link>
                </div>
              </div>
            )}
          </div>

          {/* Profile Menu */}
          <div className="topbar-profile">
            <div 
              className="profile-info-wrapper"
              onClick={(e) => {
                e.stopPropagation();
                toggleDropdown('profile');
              }}
            >
              <img 
                style={{marginRight: '10px', marginTop: '15px'}}
                src={userData?.profile_image || "/images/profile.png"} 
                alt="Profile" 
                className="profile-avatar" 
              />
              <div className="profile-info">
                <span className="profile-name">
                  {currentUser ? `${currentUser.user.name}` : currentUser?.user?.email}
                </span>
                <span className="profile-role">Landlord</span>
              </div>
            </div>

            {activeDropdown === 'profile' && (
              <div className="topbar-dropdown messages-dropdown">
                
                <Link to="/landlord/profile" className="dropdown-item">
                  <i className="fas fa-user"></i>
                  <span>Profile</span>
                </Link>
                <Link to="/landlord/settings" className="dropdown-item">
                  <i className="fas fa-cog"></i>
                  <span>Settings</span>
                </Link>
                <div className="dropdown-divider"></div>
                <Link to="/logout" className="dropdown-item text-danger">
                  <i className="fas fa-sign-out-alt"></i>
                  <span>Logout</span>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar; 